import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DraggableListMlComponent } from './draggable-list-ml.component';
import { AccordionModule } from '../accordion/accordion.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DragulaModule } from 'ng2-dragula';

@NgModule({
  declarations: [DraggableListMlComponent],
  imports: [CommonModule, AccordionModule, SharedModule, DragulaModule.forRoot()],
  exports: [DraggableListMlComponent]
})
export class DraggableListMlModule {}
